export enum TaskStatusValues {
    OPEN = 1,
    CLOSED = 2,
}
